import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './OwnerSideBar.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faTachometerAlt,
  faTools,
  faBuilding,
  faBoxes,
  faUsers,
  faUserCog,
  faMoneyBillWave,
  faChartBar,
  faBell,
  faEnvelope,
  faSignOutAlt,
  faChartLine,
  faDollarSign,
  faBars,
  faTimes
} from '@fortawesome/free-solid-svg-icons';

const ManagerSidebar = ({ children }) => {
  const [isReportOpen, setIsReportOpen] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleReportDropdown = () => setIsReportOpen(!isReportOpen);
  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);
  const closeSidebar = () => setIsSidebarOpen(false);

  return (
    <div className="layout">
      {/* Hamburger button visible on mobile */}
      <div className="hamburger" onClick={toggleSidebar}>
        <FontAwesomeIcon icon={isSidebarOpen ? faTimes : faBars} />
      </div>

      {/* Sidebar */}
      <div className={`sidebar ${isSidebarOpen ? 'open' : ''}`}>
        <h2>Owner</h2>
        <ul>
          <li><Link to="/manager"><FontAwesomeIcon icon={faTachometerAlt} /> Dashboard</Link></li>
          <li><Link to="/manager/Maintenance"><FontAwesomeIcon icon={faTools} /> Maintenance</Link></li>
          <li><Link to="/manager/apartment-units"><FontAwesomeIcon icon={faBuilding} /> Apartment Units</Link></li>
          <li><Link to="/manager/MaterialsManagement"><FontAwesomeIcon icon={faBoxes} /> Materials</Link></li>
          <li><Link to="/manager/tenants"><FontAwesomeIcon icon={faUsers} /> Tenants</Link></li>
          <li><Link to="/manager/accounts"><FontAwesomeIcon icon={faUserCog} /> Accounts</Link></li>
          {/* <li><Link to="/manager/Home"><FontAwesomeIcon icon={faUserCog} /> Manage Home Page</Link></li>
          <li><Link to="/manager/Slide"><FontAwesomeIcon icon={faUserCog} /> Manage Slides</Link></li> */}
          <li><Link to="/manager/Expences"><FontAwesomeIcon icon={faMoneyBillWave} /> Expenses</Link></li>
          <li onClick={toggleReportDropdown} style={{ cursor: 'pointer' }}>
            <FontAwesomeIcon icon={faChartBar} /> Report ▾
            {isReportOpen && (
              <ul className="dropdown">
                <li><Link to="/reports/expenses"><FontAwesomeIcon icon={faMoneyBillWave} /> Expenses</Link></li>
                <li><Link to="/reports/income"><FontAwesomeIcon icon={faDollarSign} /> Income</Link></li>
                <li><Link to="/profit-loss-report"><FontAwesomeIcon icon={faChartLine} /> Profit/Loss</Link></li>
              </ul>
            )}
          </li>
          <li><Link to="/manager/notification"><FontAwesomeIcon icon={faBell} /> Notifications</Link></li>
          <li><Link to="/manager/messagecontact"><FontAwesomeIcon icon={faEnvelope} /> Contact Messages</Link></li>
          <li><Link to="/"><FontAwesomeIcon icon={faSignOutAlt} /> Log Out</Link></li>
        </ul>
      </div>

      {/* Overlay when sidebar is open on mobile */}
      {isSidebarOpen && <div className="overlay" onClick={closeSidebar}></div>}

      {/* Main content */}
      <div className="main-content">
        {children}
      </div>
    </div>
  );
};

export default ManagerSidebar;
